import React from 'react';
import classnames from 'classnames';

import { section } from './styles.module.scss';

const DefaultContent = ({ content }) => {
  return (
    <section className={classnames(section)}>
      <article className="sm:pb-12 sm:border-b sm:border-mercury">
        {content}
      </article>
    </section>
  );
};

export default DefaultContent;
